import { DELETE_CAROUSEL, GET_CAROUSEL, SET_CAROUSEL } from "./actionType"

export const setCarousel = (carousel) => {
    return{
        type: SET_CAROUSEL,
        payload: carousel,

    }
};

export const getCarousel = (carouselData) => {
    return{
        type: GET_CAROUSEL,
        payload: carouselData,
    }
};

export const deleteCarousel = (id, photo) => {
    return{
        type: DELETE_CAROUSEL,
        payload: {id, photo},
    }
};